export const XHR_BASE_PATH = '/_napi/da-user-profile/';
export const API_BASE_PATH = `${XHR_BASE_PATH}api`;
export const SHARED_API_BASE_PATH = `${XHR_BASE_PATH}shared_api`;
export const PUBLIC_API_BASE_PATH = '/_puppy/v1/dauserprofile';
export const GROUP_CREATION_PATH = '/groups/create';
